import { useMemo, useState } from "react"
import { DashBoardConfigure } from "../types"
import {
	FormControl,
	MenuItem,
	Select,
  Stack,
  Typography
} from "@mui/material"
import { getKeyColumns } from 'features/dashBoard/util'
import { TargetListResult } from "interface/search/targetList"
import { getAxisTitle, KeyOfTargetListCategory } from "features/search/targetList/util"

const empty = "**"

type GlobalAxisSelectProps<T> = {
  readonly configure: DashBoardConfigure<T>
  targetList?: TargetListResult | null
	globalAxisKey: string | undefined
	setGlobalAxisKey: (key: string | undefined) => void
}
export const GlobalAxisSelect = <T,>({
	configure,
  targetList,
	globalAxisKey,
	setGlobalAxisKey
}: GlobalAxisSelectProps<T>) => {
  const [open, setOpen] = useState(false)
  const columnList = useMemo(
    () => getKeyColumns(configure.axis, configure.category),
    [configure.axis, configure.category]
  )
  return (
    <FormControl>
      <Select
        open={open}
        id={`global-axis-key`}
        size="small"
        value={globalAxisKey ?? empty}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        onChange={(event) => setGlobalAxisKey(event.target.value)}
        renderValue={(selected: string) => {
          if (selected === empty) return "なし"
          return getAxisTitle(configure, selected, targetList) ?? '不明'
        }}
      >
				<MenuItem
          key={`choice-empty`}
          value={empty}
        >
					なし
				</MenuItem>

        {Object.keys(configure.axis).map((key, i) => (
          <MenuItem
            key={`hidden-global-axis-${key}-${i}`}
            value={key}
            style={{ display: "none" }}
          >
            {configure.axis[key].title}
          </MenuItem>
        ))}
        {targetList?.category?.map((category, i) => (
          <MenuItem
            key={`hidden-global-target-category-${i}`}
            value={`${KeyOfTargetListCategory}${category.sequence}`}
            style={{ display: "none" }}
          >
            {category.title}
          </MenuItem>
        ))}

        <Stack direction="row">
          {columnList.map((column, i) => (
            <Stack key={`global-axis-column-${i}`} direction="column">
              {column.category.map((category, j) => (
                <Stack key={`global-axis-category-${i}-${j}`} direction="column">
                  {category.title !== "" && (
                    <Typography variant='caption' component="div" paddingX={1} color="text.secondary" marginTop={1}>
                      {category.title}
                    </Typography>
                  )}
                  {category.keys.map((key, k) =>
                    <MenuItem
                      key={`global-axis-${i}-${j}-${k}-${key}`}
                      selected={key === globalAxisKey}
                      onClick={() => {
                        setGlobalAxisKey(key)
                        setOpen(false)
                      }}
                    >
                      {configure.axis[key].title}
                    </MenuItem>
                  )}
                </Stack>
              ))}
            </Stack>
          ))}

          {targetList?.category && (
            <Stack key="global-axis-target-category" direction="column">
              {targetList.category.map((category, i) =>
                <MenuItem
                  key={`global-axis-taget-category-${i}-${category.sequence}`}
                  selected={globalAxisKey === `${KeyOfTargetListCategory}${category.sequence}`}
                  onClick={() => {
                    setGlobalAxisKey(`${KeyOfTargetListCategory}${category.sequence}`)
                    setOpen(false)
                  }}
                >
                  {category.title}
                </MenuItem>
              )}
            </Stack>
          )}
        </Stack>
      </Select>
    </FormControl>
  )
}
